import { WingsNationalMenuData } from './types';

const wings: WingsNationalMenuData = {
  title: 'Wings',
  subtitle: 'With 9 signature sauces and rubs to choose from, we\'re tossing up the freshest flavors you crave.',
  sauces: {
    name: 'Sauces',
    content: [
      {
        level: 1,
        alt: 'Heat level 1 out of 5',
        flavor: 'Garlic parmesan'
      },
      {
        level: 1,
        alt: 'Heat level 1 out of 5',
        flavor: 'Honey BBQ'
      },
      {
        level: 2,
        alt: 'Heat level 2 out of 5',
        flavor: 'Buffalo mild'
      },
      {
        level: 2,
        alt: 'Heat level 2 out of 5',
        flavor: 'Spicy garlic'
      },
      {
        level: 3,
        alt: 'Heat level 3 out of 5',
        flavor: 'Buffalo medium'
      },
      {
        level: 3,
        alt: 'Heat level 3 out of 5',
        flavor: 'Sweet chili'
      },
      {
        level: 4,
        alt: 'Heat level 4 out of 5',
        flavor: 'Buffalo burnin’ hot'
      }
    ]
  },
  dryRubs: {
    name: 'Dry rubs',
    content: [
      {
        level: 1,
        alt: 'Heat level 1 out of 5',
        flavor: 'Lemon pepper'
      },
      {
        level: 2,
        alt: 'Heat level 2 out of 5',
        flavor: 'Cajun-style'
      }
    ]
  },
  wingTypes: {
    name: 'Wing types',
    content: [
      {
        name: 'Classic bone-in',
        description: 'Eating these classic, crispy bone-in wings is the easy part. Choosing from Sweet chili, Garlic parmesan, Honey BBQ or our Lemon pepper...well, good luck there.',
        image: {
          desktop: '/images/nationalMenu/wings/National_Wings_Traditional.jpg',
          mobile: '/images/nationalMenu/wings/National_Wings_Traditional.jpg',
          altText: 'Classic bone-in'
        }
      },
      {
        name: 'Breaded boneless',
        description: 'All the wings. None of the work. Get these tasty, 100% all-white meat boneless wings tossed in your favorite sauce.',
        image: {
          desktop: '/images/nationalMenu/wings/National_Wings_Boneless.jpg',
          mobile: '/images/nationalMenu/wings/National_Wings_Boneless.jpg',
          altText: 'Breaded boneless'
        }
      }
    ]
  },
  fries: {
    name: 'Fries',
    content: [
      {
        name: 'Straight-cut',
        description: 'Crispy & delicious. Get ‘em with or without seasoning.',
        image: {
          desktop: '/images/nationalMenu/wings/National_Wings_StraightCutFries.jpg',
          mobile: '/images/nationalMenu/wings/National_Wings_StraightCutFries.jpg',
          altText: 'Straight-cut'
        }
      },
      {
        name: 'Lemon pepper',
        description: 'Crispy fries with a bold, zesty kick.',
        image: {
          desktop: '/images/nationalMenu/wings/National_Wings_LemonPepperFries.jpg',
          mobile: '/images/nationalMenu/wings/National_Wings_LemonPepperFries.jpg',
          altText: 'Lemon pepper'
        }
      },
      {
        name: 'Cajun style',
        description: ' Crispy fries with a spicy, Cajun-inspired kick.',
        image: {
          desktop: '/images/nationalMenu/wings/National_Wings_CajunStyleFries.jpg',
          mobile: '/images/nationalMenu/wings/National_Wings_CajunStyleFries.jpg',
          altText: 'Cajun style'
        }
      }
    ]
  },
  dontSkipTheDip: {
    name: 'Don’t Skip the Dip®',
    description: 'Dunk those crispy-fried wings in a mouthwatering dip of your choice.',
    content: [
      {
        name: 'Ranch',
        image: {
          desktop: '/images/nationalMenu/wings/National_Wings_Dips_Ranch.jpg',
          mobile: '/images/nationalMenu/wings/National_Wings_Dips_Ranch.jpg',
          altText: 'Ranch'
        }
      },
      {
        name: 'Blue Cheese',
        image: {
          desktop: '/images/nationalMenu/wings/National_Wings_Dips_BlueCheese.jpg',
          mobile: '/images/nationalMenu/wings/National_Wings_Dips_BlueCheese.jpg',
          altText: 'Blue Cheese'
        }
      },
      {
        name: 'Garlic',
        image: {
          desktop: '/images/nationalMenu/wings/National_Wings_Dips_Garlic.jpg',
          mobile: '/images/nationalMenu/wings/National_Wings_Dips_Garlic.jpg',
          altText: 'Garlic'
        }
      },
      {
        name: 'Honey BBQ',
        image: {
          desktop: '/images/nationalMenu/wings/National_Wings_Dips_HoneyBBQ.jpg',
          mobile: '/images/nationalMenu/wings/National_Wings_Dips_HoneyBBQ.jpg',
          altText: 'Honey BBQ'
        }
      },
      {
        name: 'Buffalo',
        image: {
          desktop: '/images/nationalMenu/wings/National_Wings_Dips_Buffalo.jpg',
          mobile: '/images/nationalMenu/wings/National_Wings_Dips_Buffalo.jpg',
          altText: 'Buffalo'
        }
      },
      {
        name: 'Marinara',
        image: {
          desktop: '/images/nationalMenu/wings/National_Wings_Dips_Marinara.jpg',
          mobile: '/images/nationalMenu/wings/National_Wings_Dips_Marinara.jpg',
          altText: 'Marinara'
        }
      }
    ]
  }
};

export default wings;
